// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var modifyRef = function (ref) {
    return function (f) {
        return function __do() {
            var x = $foreign.readRef(ref)();
            return $foreign.writeRef(ref)(f(x))();
        };
    };
};
module.exports = {
    modifyRef: modifyRef,
    newRef: $foreign.newRef,
    readRef: $foreign.readRef,
    writeRef: $foreign.writeRef,
    emptyDelayed: $foreign.emptyDelayed,
    pushDelayed: $foreign.pushDelayed,
    unsafeFreezeDelayed: $foreign.unsafeFreezeDelayed,
    sequenceEffects: $foreign.sequenceEffects
};
//# sourceMappingURL=index.js.map
